class BbdBlogBreadcrumbs extends HTMLElement {
  connectedCallback() {
    this.#upgradeBackLink();
  }

  #upgradeBackLink() {
    const shopUrl = this.dataset.shopUrl;

    try {
      const stored = localStorage.getItem('bbd_last_blog');
      if (!stored) return;

      const { url, title } = JSON.parse(stored);
      if (!url || !title) return;

      // Validate same origin
      const shopOrigin = new URL(shopUrl).origin;
      const blogOrigin = new URL(url).origin;
      if (blogOrigin !== shopOrigin) return;

      const backLink = this.querySelector('.back-link');
      if (!backLink) return;

      backLink.href = url;

      const titleEl = backLink.querySelector('.bbd-blog-breadcrumbs__back-text');
      if (titleEl) titleEl.textContent = title;

      localStorage.removeItem('bbd_last_blog');
    } catch {
      // Malformed data — silently ignore
    }
  }
}

customElements.define('bbd-blog-breadcrumbs', BbdBlogBreadcrumbs);
